import { Reveal } from "../components/Reveal";
import { Link } from "react-router-dom";

const KUTTY_IMG = "https://customer-assets-cm19k8pv.emergentagent.net/job_kasavu-threads/artifacts/tgbrofps_WhatsApp%20Image%202026-08-08%20at%2012.47.46%20PM.jpeg";

export default function Story() {
  return (
    <div data-testid="story-page" className="pt-32">
      {/* Header */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-20 md:pb-28">
        <Reveal><span className="overline text-mj-golddeep">Our Story</span></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif-mj tracking-tight text-mj-text mt-6 text-5xl sm:text-6xl lg:text-8xl leading-[0.95]">
            Traditions that<br/><span className="italic text-mj-red">bring us together</span>
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-sans-mj text-mj-muted leading-relaxed mt-10 max-w-2xl text-lg">
            Every family has traditions that bring them together and at Manjaadii, we're proud to be a small part of those moments. Inspired by the beauty of Kerala and rooted in Bangalore, we offer ethnic wear that feels familiar, comfortable, and made for celebrating life's special occasions.
          </p>
        </Reveal>
      </section>

      {/* Chapter 01 */}
      <section className="bg-mj-surface/40 border-y border-mj-border py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-3">
            <Reveal><span className="font-serif-mj text-8xl text-mj-gold/50">01</span></Reveal>
          </div>
          <div className="md:col-span-9">
            <Reveal delay={0.1}><h2 className="font-serif-mj text-3xl md:text-5xl tracking-tight text-mj-text leading-tight">Chosen with love and care</h2></Reveal>
            <Reveal delay={0.2}>
              <p className="font-sans-mj text-mj-muted leading-relaxed mt-8 max-w-2xl">
                Whether it's a festival, a wedding, or a simple gathering at home, our collections are chosen with love and care. At Manjaadii, we believe the best outfits aren't just worn, they become part of the memories you make with the people you love.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Manjaadii Kutty */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <Reveal>
            <div className="relative">
              <div className="aspect-[3/4] overflow-hidden border border-mj-border">
                <img src={KUTTY_IMG} alt="Manjaadii Kutty" className="w-full h-full object-cover object-top" data-testid="kutty-image" />
              </div>
              <div className="absolute -bottom-5 -left-5 bg-mj-red text-mj-bg px-6 py-4">
                <span className="font-serif-mj italic text-2xl">Manjaadii Kutty</span>
              </div>
            </div>
          </Reveal>
          <div>
            <Reveal><span className="overline text-mj-golddeep">Chapter 02 · Behind it all</span></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-mj text-4xl md:text-5xl tracking-tight text-mj-text mt-5 leading-tight">
                Banker, dancer, now a <span className="italic text-mj-red">free-spirited rider</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="font-sans-mj text-mj-muted leading-relaxed mt-8">
                Behind the brand is our Manjaadii kutty, a seasoned banker and avid rider who dances on the corridors of temples. Who understands the poetry of fabric, movement and grace. What started as a personal love for Kerala's weaves grew into a carefully curated label based in Bangalore, connecting traditional weavers with women who want ethnic wear that feels authentic and wearable. Every piece is chosen for its craft, comfort, and the quiet confidence it gives the woman who wears it, the same quiet strength and beauty she carries from the stage to the everyday.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Chapter 03 */}
      <section className="bg-mj-red text-mj-bg py-24 md:py-40 relative overflow-hidden">
        <span className="absolute right-0 top-1/2 -translate-y-1/2 font-serif-mj text-mj-gold/10 text-[30vw] leading-none select-none">03</span>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
          <Reveal><span className="overline text-mj-golddeep">The label</span></Reveal>
          <Reveal delay={0.1}>
            <p className="font-serif-mj text-3xl md:text-5xl lg:text-6xl leading-[1.15] tracking-tight mt-8 max-w-4xl">
              What began as her own deep love for Kerala's weaves has grown into a carefully curated label, connecting the hands of traditional weavers with women who want ethnic wear that feels true, beautiful, and completely wearable.
            </p>
          </Reveal>
          <div className="kasavu-border my-16 opacity-40" />
          <Reveal delay={0.2}>
            <p className="font-sans-mj leading-relaxed max-w-2xl text-mj-bg/80">
              Every piece is chosen for its craft, its comfort, and the soft confidence it gives the woman who wears it, the same strength and beauty our Manjaadii kutty carries so naturally, from temple steps to everyday streets.
            </p>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 text-center">
        <Reveal><h2 className="font-serif-mj text-4xl md:text-6xl tracking-tight text-mj-text">Become part of the story</h2></Reveal>
        <Reveal delay={0.1}>
          <Link to="/collection" data-testid="story-collection-cta" className="inline-block mt-10 bg-mj-red text-mj-bg px-10 py-4 overline hover:bg-mj-reddark transition-colors">Explore the Collection</Link>
        </Reveal>
      </section>
    </div>
  );
}
